<template>
  <div
    v-if="isUnreadFailed"
    class="flex justify-center items-center bg-new-red-100"
  >
    <div class="flex justify-between w-full max-w-[408px]">
      <div class="text-sm py-2 px-4">
        <div class="font-bold">交易失敗</div>
        <div class="text-new-gray-700">請查看詳情，確認失敗原因</div>
      </div>
      <div class="flex items-center cursor-pointer">
        <div
          class="bg-new-red-500 text-white font-medium px-4 py-2 rounded"
          @click="goTransactionFailed"
        >
          查看詳情
        </div>
        <div
          class="w-12 h-12 flex justify-center items-center"
          @click="isUnreadFailed = false"
        >
          <img
            src="@/assets/images/circle-close.svg"
            alt="times-circle"
            class="w-5 h-5"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransactionFailedNotification",
  props: {
    apiBaseUrl: {
      type: String,
      default: () => "/trade/api",
    },
  },
  data() {
    return {
      isUnreadFailed: false,
    };
  },
  computed: {
    isFundswapTrade() {
      return window.location.href && window.location.href.includes("/trade");
    },
  },
  methods: {
    async fetchTransactions() {
      if (this.isFundswapTrade) {
        this.$HowHowApi
          .tenantFundTransactions()
          .then((response) => {
            let data = response.data;
            if (!data) return;

            this.isUnreadFailed = data.unreadFailed;
          })
          .catch(() => {});
      } else {
        const response = await fetch(
          `${this.apiBaseUrl}/tenant/fund-transactions`,
          { credentials: "include" }
        );
        if (response.status === 200) {
          const data = await response.json();
          this.isUnreadFailed = data.unreadFailed;
        }
      }
    },
    goTransactionFailed() {
      if (this.isFundswapTrade) {
        this.$router.push({
          name: "transactions",
          query: { blockIndex: 1, status: "failed" },
        });
      } else {
        const baseUrl = "/trade/transactions";
        const queryParams = new URLSearchParams({
          blockIndex: 1,
          status: "failed",
        }).toString();
        window.location.href = `${baseUrl}?${queryParams}`;
      }

      this.isUnreadFailed = false;
    },
  },
  mounted() {
    this.fetchTransactions();
  },
};
</script>

<style lang="scss" scoped>
@use "tailwindcss/base" as base;
@use "tailwindcss/components" as components;
@use "tailwindcss/utilities" as utilities;

:root {
  --condition: #{isFundswapTrade};
}

@if not var(--condition) {
  base components utilities * {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #f5f5f5;
  }
}
</style>
